<div class="navigation-menu-container" [ngClass]="{'menu-container-expand':!isNavigationCollapse}"
    *ngIf="!isNavigationDataReady || !isLivewireDataReady">
</div>
<div tid="navigation-menu-container" class="navigation-menu-container"
    [ngClass]="{'menu-container-expand':!isNavigationCollapse}" *ngIf="isNavigationDataReady && isLivewireDataReady">
    <div class="tamale-icon-container">
        <smart-icon tid="tamale_home_icon" name="tamale-home-icon" class="tamale-icon light" (click)="goHome($event)">
        </smart-icon>
        <label class="tamale-label">TAMALE RMS</label>
    </div>
    <div class="menu-container">
        <ul class="ul-container" [ngClass]="{'menu-container-expand':!isNavigationCollapse}"
            (mouseover)="menuOnMouseOver($event)" (mouseleave)="menuOnMouseOut($event)"
            [ngStyle]="{'height':isIPAD === true ? '100%' : 'calc(100% - 46px)'}">
            <li *ngFor="let menu of navigationMenuContainer;let i = index; trackBy:trackByFn"
                (mouseover)="menuOnItemOver($event,menu)">
                <ng-container *ngIf="!menu.hide">
                    <div class="div-container"
                        [ngClass]="{'div-border-selected':selectedMenu===menu.type,'div-container-expand':!isNavigationCollapse}"
                        (click)="itemOnClick($event,menu)" *ngIf="!menu.routerLink">
                        <div class="icon-container" [attr.tid]="menu.tid">
                            <smart-icon class="menu-image" [ngClass]="{'menu-image-selected':selectedMenu===menu.type}"
                                [name]="menu.icon.name"></smart-icon>
                        </div>
                        <div *ngIf="isNavigationCollapse" class="div-placeholder"
                            (mouseover)="placeholderOnMouseOver($event)"></div>
                        <label *ngIf="!isNavigationCollapse" class="menu-label">{{menu.caption}}</label>
                        <smart-icon class="menu-image label_arrow" name="angle-right"
                            *ngIf="menu.items&&!isNavigationCollapse"></smart-icon>
                    </div>
                    <a class="a-container"
                        [ngClass]="{'div-border-selected':selectedMenu===menu.type,'div-container-expand':!isNavigationCollapse}"
                        (click)="itemOnClick($event,menu)" *ngIf="menu.routerLink" [href]="menu.routerLink">
                        <div class="icon-container" [attr.tid]="menu.tid">
                            <smart-icon class="menu-image" [ngClass]="{'menu-image-selected':selectedMenu===menu.type}"
                                [name]="menu.icon.name"></smart-icon>
                        </div>
                        <div *ngIf="isNavigationCollapse" class="div-placeholder"
                            (mouseover)="placeholderOnMouseOver($event)"></div>
                        <label *ngIf="!isNavigationCollapse" class="menu-label">{{menu.caption}}</label>
                        <smart-icon class="menu-image label_arrow" name="angle-right"
                            *ngIf="menu.items&&!isNavigationCollapse"></smart-icon>
                    </a>
                    <ul *ngIf="menu.items&&hoverMenu===menu.id" [ngClass]="{'sub-menu-ul':!menu.canAdd}">
                        <div class="cushion" [ngClass]="{'cushion-empty':menu.items.length===0}">
                            <li *ngIf="menu.type==='workflow' && canCreateWorkflow" class="create-li">
                                <div class="create-container">
                                    <div class="import-item" (click)="onImportConfigFile(menu)">
                                        <div>
                                            <smart-icon class="create-smart-icon" name="add"></smart-icon>
                                        </div>
                                        <div>
                                            <label class="create-label">Import From
                                                Configuration File</label>
                                        </div>
                                    </div>
                                    <input id="file-selector" type="file" class="file-selector"
                                        accept="application/json">
                                </div>
                                <p *ngIf="!menu.canAdd" class="create-sperater">
                                </p>
                            </li>
                            <li *ngIf="menu.canAdd" class="create-li" (click)="onClickCreateItem(menu)">
                                <div class="create-container">
                                    <div class="create-item">
                                        <div>
                                            <smart-icon class="create-smart-icon" name="add"></smart-icon>
                                        </div>
                                        <label *ngIf="menu.type==='research'" class="create-label">
                                            Create {{menu.caption}} View
                                        </label>
                                        <label *ngIf="menu.type!=='research'" class="create-label">
                                            Create {{menu.caption}}
                                        </label>
                                    </div>
                                </div>
                                <p class="create-sperater">
                                </p>
                            </li>
                            <!-- do not remove white space in calc function -->
                            <div class="item-container" [style.max-height]="'calc(100vh - '+(64+46*(i+1))+'px)'">
                                <span *ngFor="let subMenu of menu.items;let j = index; trackBy:trackByFn">
                                    <a class="submenu-item" *ngIf="!subMenu.useWidget" [href]="subMenu.routerLink"
                                        (click)="subItemOnClick($event,subMenu)">
                                        <div class="submenu">
                                            <a class="link">
                                                <smart-icon *ngIf="subMenu.icon.name" [name]="subMenu.icon.name">
                                                </smart-icon>
                                                <div class="submenu-word">{{subMenu.caption}}</div>
                                            </a>
                                        </div>
                                    </a>
                                    <ul *ngIf="!!subMenu.useWidget">
                                        <navigation-menu-item [item]="subMenu" [touchMode]='isIPAD' [seperator]='false'
                                            [eventSubject]='eventSubject$'></navigation-menu-item>
                                    </ul>
                                </span>
                            </div>
                        </div>
                    </ul>
                </ng-container>
            </li>
        </ul>
        <a *ngIf="!isIPAD" class="settings-icon-container"
            [ngClass]="{'menu-container-expand':!isNavigationCollapse, 'div-border-selected':selectedMenu==='settings'}"
            (click)="itemOnClick($event,'settings')" (mouseover)="settingsOnMouseOver($event)"
            (mouseleave)="settingsOnMouseOut($event)" href="settings">
            <div class="icon-container" tid="settings">
                <smart-icon class="menu-image" [ngClass]="{'menu-image-selected':selectedMenu==='settings'}"
                    name="layers">
                </smart-icon>
            </div>
            <div *ngIf="isNavigationCollapse" class="div-placeholder" (mouseover)="placeholderOnMouseOver($event)">
            </div>
            <label *ngIf="!isNavigationCollapse" class="menu-label">Manage Screens</label>
        </a>
    </div>
</div>